/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Audit_TextInputs */

const cs_gdpr_audit_text = /** @type {(inputs: Gdpr_Audit_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

const en_gdpr_audit_text = /** @type {(inputs: Gdpr_Audit_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

/**
* | output |
* | --- |
* | "Text" |
*
* @param {Gdpr_Audit_TextInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_audit_text = /** @type {((inputs?: Gdpr_Audit_TextInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Audit_TextInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_audit_text(inputs)
	return cs_gdpr_audit_text(inputs)
});